import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    background: ${theme.v2.colors.neutral.highPure};
    padding: 20px 24px;
    gap: 10px;
    border-radius: 16px;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding: 16px 20px;  
      border-radius: 0;
      overflow-x: scroll;

      -ms-overflow-style: none;  /* Internet Explorer 10+ */
      scrollbar-width: none;  /* Firefox */
      &::-webkit-scrollbar {
        display: none;  /* Safari and Chrome */
      }
    }
  `}
`;

export const Button = styled.button`
  ${({ theme, active }) => css`
    align-items: center;
    backdrop-filter: blur(16px);
    background: ${active ? theme.v2.colors.brand.primaryLowLight : 'rgba(255, 255, 255, 0.16)'};
    border-radius: 39.5px;
    border: 1px solid #fff;
    border-color: ${active ? theme.v2.colors.brand.primaryLowLight : theme.v2.colors.neutral.highMedium};
    color: ${active ? theme.v2.colors.brand.primaryMedium : theme.v2.colors.neutral.lowPure};
    cursor: pointer;
    display: flex;
    flex-wrap: nowrap;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    gap: 8px;
    height: 48px;
    justify-content: center;
    padding: 12px 24px;
    white-space: nowrap; 

    :hover {
      background: ${!active && 'rgba(255, 255, 255, 0.24)'};
    }

    svg {
      path {
        stroke: ${active ? theme.v2.colors.brand.primaryMedium : theme.v2.colors.neutral.lowPure};
        fill: none;
      }
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xxs};
      height: 38px;
      padding: 7px 16px;
    }
  `}
`;
